import Config from 'app/utils/config'
import { Mixpanel } from 'mixpanel-react-native'

let mixpanelObj: Mixpanel | null = null

export function initMixpanel() {
  getMixpanelObj()?.init()
}

/**
 * Function to return singleton instance of mixpanel obj
 */
export function getMixpanelObj() {
  const { MIXPANEL_TOKEN_KISAN_WEB } = Config
  if (MIXPANEL_TOKEN_KISAN_WEB) {
    if (!mixpanelObj) {
      const trackAutomaticEvents = true
      mixpanelObj = new Mixpanel(MIXPANEL_TOKEN_KISAN_WEB, trackAutomaticEvents)
    }
    return mixpanelObj
  }
}
